const toLocalDateString = (date: Date) => {
  const year = date.getFullYear()
  const month = `${date.getMonth() + 1}`.padStart(2, '0')
  const day = `${date.getDate()}`.padStart(2, '0')
  return `${year}-${month}-${day}`
}

export const toDateInputValue = (value?: string | Date | null) => {
  if (!value) return ''
  if (value instanceof Date) return Number.isNaN(value.getTime()) ? '' : toLocalDateString(value)
  const matched = value.match(/^(\d{4}-\d{2}-\d{2})/)
  if (matched) return matched[1]
  const date = new Date(value)
  return Number.isNaN(date.getTime()) ? '' : toLocalDateString(date)
}

export const toDisplayDate = (value?: string | null) => {
  const normalized = toDateInputValue(value)
  if (!normalized) return ''
  const [year, month, day] = normalized.split('-')
  return `${day}/${month}/${year}`
}
